import React from 'react';
import { Section } from './ui/Section';
import { Zap, ShieldCheck, Activity } from 'lucide-react';
export function MechanismSection() {
  return <Section data-id="element-432">
      <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-433">
        <div className="relative" data-id="element-434">
          <img src="https://images.unsplash.com/photo-1587854692152-cbe660dbde88?auto=format&fit=crop&q=80" alt="Estructura molecular del veneno de abeja" className="rounded-2xl shadow-2xl w-full" data-id="element-435" />
          <div className="absolute inset-0 bg-gradient-to-tr from-[#2D5016]/20 to-transparent rounded-2xl" data-id="element-436"></div>
        </div>

        <div data-id="element-437">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" data-id="element-438">
            Por qué StingFit funciona cuando todo lo demás falló
          </h2>
          <p className="text-lg text-gray-600 mb-8" data-id="element-439">
            La mayoría de soluciones solo atacan la grasa. StingFit tiene un
            enfoque dual:{' '}
            <span className="font-bold text-[#2D5016]" data-id="element-440">
              activa tu metabolismo para quemar grasa Y elimina la inflamación
            </span>
            .
          </p>

          <div className="space-y-6" data-id="element-441">
            <div className="flex gap-4" data-id="element-442">
              <div className="w-12 h-12 bg-[#D4AF37]/10 rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-443">
                <Zap className="w-6 h-6 text-[#D4AF37]" data-id="element-444" />
              </div>
              <div data-id="element-445">
                <h3 className="font-bold text-gray-900 text-lg" data-id="element-446">
                  Activación Metabólica con Veneno de Abeja
                </h3>
                <p className="text-gray-600" data-id="element-447">
                  Estimula la circulación y activa el metabolismo local en la
                  zona abdominal, promoviendo la movilización de grasa
                  almacenada y el efecto termogénico.
                </p>
              </div>
            </div>

            <div className="flex gap-4" data-id="element-448">
              <div className="w-12 h-12 bg-[#D4AF37]/10 rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-449">
                <Activity className="w-6 h-6 text-[#D4AF37]" data-id="element-450" />
              </div>
              <div data-id="element-451">
                <h3 className="font-bold text-gray-900 text-lg" data-id="element-452">
                  Drenaje Linfático y Reducción de Inflamación
                </h3>
                <p className="text-gray-600" data-id="element-453">
                  Ayuda a tu cuerpo a eliminar líquidos retenidos y toxinas que
                  causan esa apariencia de "barriga hinchada", revelando tu
                  verdadera silueta.
                </p>
              </div>
            </div>

            <div className="flex gap-4" data-id="element-454">
              <div className="w-12 h-12 bg-[#D4AF37]/10 rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-455">
                <ShieldCheck className="w-6 h-6 text-[#D4AF37]" data-id="element-456" />
              </div>
              <div data-id="element-457">
                <h3 className="font-bold text-gray-900 text-lg" data-id="element-458">
                  Seguro y Sin Efectos Secundarios
                </h3>
                <p className="text-gray-600" data-id="element-459">
                  Ingredientes naturales que trabajan con tu cuerpo, no contra
                  él. Acción dual: quema grasa y reduce inflamación de forma
                  natural.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Section>;
}